import React                from "react"
import {useHistory}         from "react-router"

import {IonList, IonRow, IonCol, IonGrid, IonAccordionGroup} from "@ionic/react"

import {PersonGroup as ItemType}    from "../../types/PersonGroup"
import {usePersonGroups as useItems} from "../../contexts/PersonGroupContext"
import {useAuth}               from "../../contexts/AuthContext"
import {useLockingSystems}     from "../../contexts/LockingSystemContext"
import LockingSystem           from "../../types/LockingSystem"

import FormAccordionLockingSystem from "./Form/AccordionLockingSystem"
import FormAccordionPersonGroup   from "./Form/AccordionPersonGroup"

import FormButtonSaveChanges      from "../common/Buttons/FormButtonSaveChanges"
import FormButtonSaveNew          from "../common/Buttons/FormButtonSaveNew"


interface formProps {
    item: ItemType | undefined;
}

const Form: React.FC<formProps> = ({ item }) => {

    const { editItem, message } = useItems()
    const { selectedLockingSystemId }    = useLockingSystems()

    const initialFormData: ItemType = {
        id:                     item?.id          || 0,
        dataSourceId:           item?.dataSourceId || null,
        name:                   item?.name        || '',
        description:            item?.description || '',
        isEnabled:              item?.isEnabled   || false,
        defaultNewPersonAddKey: item?.defaultNewPersonAddKey || false,
        lockingSystemId:        item?.lockingSystemId        || selectedLockingSystemId || 0,
    }

    const { userInfo  } = useAuth()
    const history       = useHistory()

    const
        [formData, setFormData] = React.useState(initialFormData),
        accordionGroupRef = React.useRef<null | HTMLIonAccordionGroupElement>(null),
        [lockingSystem, setLockingSystem] = React.useState<LockingSystem | undefined>(undefined)

    const updateFormHandler = React.useCallback(
        (type: any) => (event: any) => {
            setFormData({ ...formData, [type]: event.target.value })
        }, [formData]
    )

    React.useEffect(() => {
        setLockingSystem( userInfo?.lockingSystems?.find(item => item.id === selectedLockingSystemId) )

        if (! item && formData.lockingSystemId === 0) {
            setFormData({ ...formData, lockingSystemId: selectedLockingSystemId || 0 })
        }

    }, [formData, item, selectedLockingSystemId, userInfo])

    React.useEffect(() => {
        setFormData(initialFormData)

        if (! accordionGroupRef.current) return

        accordionGroupRef.current.value = item
            ? ['lockingSystem', 'personGroup']
            : ['personGroup']
    }, [item])


    const handleSave = async (e: any) => {
        e.preventDefault()
        e.stopPropagation()

        if (item && item.id) {

            const result = await editItem(formData)

            if (result !== undefined || message !== undefined) {
                if (result) {
                    history.push('/person-groups/' + formData.id + '/view')
                    return
                }
            }

        } else {

            // const newItem: ItemType = {...formData}
            // // delete newItem.linkKeyId
            //
            // const newPersonGroup = await addItem(newItem)
            //
            // if (newPersonGroup) {
            //     setFormData(initialFormData)
            //
            //     history.push('/people-groups/' + newPersonGroup.id + '/view')
            // }

        }
    }

    const FormKeyUp = (e: any) => {
        if (e.key === 'Enter') handleSave(e);
    }

    return (
        <IonList className="maxWidth">
            <form method="POST" id="formPersonGroup" onSubmit={handleSave} onKeyUp={ e => FormKeyUp(e) }>

                <IonAccordionGroup multiple={true} ref={accordionGroupRef}>
                    <FormAccordionLockingSystem lockingSystem={lockingSystem} />
                    <FormAccordionPersonGroup
                        formData={formData} setFormData={setFormData} updateFormHandler={updateFormHandler} />
                </IonAccordionGroup>

                <IonGrid className="ion-margin-top">
                    <IonRow>
                        <IonCol className="ion-text-right">
                            {item?.id ? <FormButtonSaveChanges /> : <FormButtonSaveNew />}
                        </IonCol>
                    </IonRow>
                </IonGrid>

            </form>
        </IonList>
    )
}

export default Form